var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            var QrCodeManager = function () {
                function QrCodeManager() {
                    _classCallCheck(this, QrCodeManager);

                    this.selector = '.js-qr-code';
                    this.endpoint = '/new/widget/qr-generate';
                    this.initializedAttr = 'qrInitialized';
                    this.loadingAttr = 'qrLoading';
                }

                _createClass(QrCodeManager, [{
                    key: "init",
                    value: function init() {
                        var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

                        this.renderAll(root);
                    }
                }, {
                    key: "renderAll",
                    value: function renderAll() {
                        var _this = this;

                        var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

                        root.querySelectorAll(this.selector).forEach(function (container) {
                            _this.render(container);
                        });
                    }
                }, {
                    key: "render",
                    value: function render(container) {
                        var _this2 = this;

                        if (!this.isValidContainer(container) || this.isProcessed(container) || this.isLoading(container)) {
                            return;
                        }

                        var payload = this.buildPayload(container);

                        if (!payload.content) {
                            return;
                        }

                        this.setLoading(container, true);

                        this.fetchQr(payload).then(function (blob) {
                            _this2.renderImage(container, blob);
                            _this2.markAsProcessed(container);
                        }).catch(function (error) {
                            console.error('QR generation failed', error);
                        }).finally(function () {
                            _this2.setLoading(container, false);
                        });
                    }
                }, {
                    key: "reload",
                    value: function reload(container) {
                        if (!this.isValidContainer(container)) {
                            return;
                        }

                        container.dataset[this.initializedAttr] = 'false';
                        this.render(container);
                    }
                }, {
                    key: "isValidContainer",
                    value: function isValidContainer(container) {
                        return container instanceof HTMLElement && container.matches(this.selector);
                    }
                }, {
                    key: "isProcessed",
                    value: function isProcessed(container) {
                        return container.dataset[this.initializedAttr] === 'true';
                    }
                }, {
                    key: "isLoading",
                    value: function isLoading(container) {
                        return container.dataset[this.loadingAttr] === 'true';
                    }
                }, {
                    key: "setLoading",
                    value: function setLoading(container, isLoading) {
                        container.dataset[this.loadingAttr] = isLoading ? 'true' : 'false';
                    }
                }, {
                    key: "markAsProcessed",
                    value: function markAsProcessed(container) {
                        container.dataset[this.initializedAttr] = 'true';
                    }
                }, {
                    key: "buildPayload",
                    value: function buildPayload(container) {
                        return {
                            content: container.dataset.qrContent || '',
                            logo: container.dataset.qrLogo || ''
                        };
                    }
                }, {
                    key: "fetchQr",
                    value: function fetchQr(payload) {
                        return fetch(this.endpoint, {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                'X-Requested-With': 'XMLHttpRequest'
                            },
                            body: this.buildRequestBody(payload).toString()
                        }).then(function (response) {
                            if (!response.ok) {
                                throw new Error('QR request failed with status ' + response.status);
                            }

                            return response.blob();
                        });
                    }
                }, {
                    key: "buildRequestBody",
                    value: function buildRequestBody(payload) {
                        var body = new URLSearchParams();
                        var csrfData = this.getCsrfData();

                        body.append('content', payload.content);
                        body.append('logo', payload.logo);

                        if (csrfData) {
                            body.append(csrfData.param, csrfData.token);
                        }

                        return body;
                    }
                }, {
                    key: "renderImage",
                    value: function renderImage(container, blob) {
                        var image = container.querySelector('img') || document.createElement('img');
                        var objectUrl = URL.createObjectURL(blob);

                        image.src = objectUrl;
                        image.alt = 'QR code';

                        if (!image.parentNode) {
                            container.appendChild(image);
                        }
                    }
                }, {
                    key: "getCsrfData",
                    value: function getCsrfData() {
                        var csrfParam = document.querySelector('meta[name="csrf-param"]');
                        var csrfToken = document.querySelector('meta[name="csrf-token"]');

                        if (!csrfParam || !csrfToken) {
                            return null;
                        }

                        return {
                            param: csrfParam.getAttribute('content'),
                            token: csrfToken.getAttribute('content')
                        };
                    }
                }]);

                return QrCodeManager;
            }();

            var qrCodeManager = new QrCodeManager();

            window.qrCodeManager = qrCodeManager;
            window.app = window.app || {};
            window.app.qrCodeManager = qrCodeManager;

            document.addEventListener('DOMContentLoaded', function () {
                qrCodeManager.init();
            });
        })();
    }, {}] }, {}, [1]);